import { autoinject, transient } from "aurelia-framework";
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import {Urls} from "../../constants/modules/survivorship-rules.constants";
import { GetMdmDataTypesResponse, GetSurvivorshipRulesResponse, SaveSurvivorshipRulesResponse } from "../../models/survivorship-rules/survivorship-rules.models";

@autoinject()
@transient()
export class SurvivorshipRulesClientService {

    constructor(private requestClient: RequestClientService) { }

    public getDataTypes(): Promise<GetMdmDataTypesResponse> {
        return this.requestClient.get(Urls.GetDataTypes, {});
    }

    public getSurvivorshipRules(dataTypeId: number): Promise<GetSurvivorshipRulesResponse> {
        return this.requestClient.get(Urls.GetSurvivorshipRules, { dataTypeId });
    }

    public saveSurvivorshipRules(rulesChanges: { mdrSurvivorshipRuleId: number, priority: number }[]): Promise<SaveSurvivorshipRulesResponse> {
        return this.requestClient.post(Urls.SaveSurvivorshipRules, {}, { rulesChanges });
    }

}